import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SupplierAutomationBox } from '../components/ControlPanelBoxes';

const SupplierAutomation = () => {
  const navigate = useNavigate();

  return (
    <main className="app-main">
      <div className="page-nav">
        <button className="back-btn" onClick={() => navigate('/control-panel')}>← Control Panel</button>
        <span className="page-nav__title">Supplier Automation</span>
      </div>

      <SupplierAutomationBox />
    </main>
  );
};

export default SupplierAutomation;
